// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.caruselItem {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
}
.caruselItem img {
  width: 100%;
  height: auto;
  object-fit: contain;
}

.image_carusel_custom_style .next {
  right: "-60px";
}
.image_carusel_custom_style .prev {
  left: 0;
}

.MuiCarouselItem-root {
  background-color: #eee;
}
.MuiCarouselItem-root .css-1abc02a {
  left: -200px;
}`, "",{"version":3,"sources":["webpack://./src/Components/ImgBox/slider/ImgSlider.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;AACJ;AAAI;EACI,WAAA;EACA,YAAA;EACA,mBAAA;AAER;;AAOI;EACI,cAAA;AAJR;AAOI;EACI,OAAA;AALR;;AASA;EACI,sBAAA;AANJ;AAOI;EACI,YAAA;AALR","sourcesContent":[".caruselItem{\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: 100%;\n    height: 100%;\n    img{\n        width: 100%;\n        height: auto;\n        object-fit: contain;\n        // object-fit: fill;\n        // max-width: 500px;\n        // max-height: 500px; \n    }\n}\n\n.image_carusel_custom_style{\n\n    .next {\n        right: '-60px'\n    }\n    // Applies to the \"prev\" button wrapper\n    .prev {\n        left: 0\n    }\n}\n\n.MuiCarouselItem-root {\n    background-color: #eee;\n    .css-1abc02a{\n        left: -200px;\n    }\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
